import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";

import p from "../img2/img2.jpeg";
import pp from "../img2/img4.jpeg";
import n2 from "../img2/img6.jpeg";
import n3 from "../img2/img5.jpeg";
import n4 from "../img2/img7.jpeg";
import n5 from "../img2/img8.jpeg";
import n6 from "../img2/img9.jpeg";

/* =========================================================
   MAIN SECTION
========================================================= */

const MainWrapper = styled.section`
  direction: rtl;
  position: relative;
  overflow: hidden;

  padding: 115px 35px 130px;

  background:
    radial-gradient(
      circle at 85% 5%,
      rgba(37, 99, 235, 0.22),
      transparent 28%
    ),
    radial-gradient(
      circle at 10% 85%,
      rgba(124, 58, 237, 0.16),
      transparent 28%
    ),
    linear-gradient(
      145deg,
      #050b16 0%,
      #081525 45%,
      #0b1d35 100%
    );

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;

    background-image:
      linear-gradient(
        rgba(255,255,255,0.025) 1px,
        transparent 1px
      ),
      linear-gradient(
        90deg,
        rgba(255,255,255,0.025) 1px,
        transparent 1px
      );

    background-size: 55px 55px;

    mask-image: linear-gradient(
      to bottom,
      black,
      transparent 90%
    );
  }

  &::after {
    content: "";
    position: absolute;
    width: 500px;
    height: 500px;
    border-radius: 50%;

    top: -250px;
    right: -200px;

    background: rgba(59, 130, 246, 0.08);
    filter: blur(90px);

    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 80px 16px 90px;
  }
`;

/* =========================================================
   HEADER
========================================================= */

const HeaderArea = styled.div`
  position: relative;
  z-index: 2;

  max-width: 900px;
  margin: 0 auto 70px;

  text-align: center;
`;

const SmallLabel = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 9px;

  padding: 8px 17px;
  margin-bottom: 20px;

  border-radius: 50px;

  color: #93c5fd;
  background: rgba(59, 130, 246, 0.09);

  border: 1px solid rgba(96, 165, 250, 0.18);

  font-size: 14px;
  font-weight: 700;

  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);

  &::before {
    content: "";
    width: 7px;
    height: 7px;

    border-radius: 50%;

    background: #60a5fa;

    box-shadow: 0 0 12px rgba(96, 165, 250, 0.9);
  }
`;

const Title = styled.h1`
  margin: 0 0 18px;

  color: #ffffff;

  font-size: clamp(42px, 5vw, 68px);
  line-height: 1.05;

  font-weight: 900;
  letter-spacing: -2.5px;

  span {
    background: linear-gradient(
      90deg,
      #60a5fa 0%,
      #818cf8 50%,
      #a78bfa 100%
    );

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  @media (max-width: 768px) {
    font-size: 43px;
    letter-spacing: -1.5px;
  }
`;

const Subtitle = styled.p`
  max-width: 720px;

  margin: 0 auto;

  color: #aebdd0;

  font-size: 18px;
  line-height: 1.85;

  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.75;
  }
`;

/* =========================================================
   GRID
========================================================= */

const ProjectsGrid = styled.div`
  position: relative;
  z-index: 2;

  display: grid;

  grid-template-columns: repeat(
    auto-fit,
    minmax(310px, 1fr)
  );

  gap: 28px;

  max-width: 1450px;

  margin: 0 auto;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 22px;
  }
`;

/* =========================================================
   CARD
========================================================= */

const Card = styled.article`
  position: relative;

  overflow: hidden;

  border-radius: 24px;

  background:
    linear-gradient(
      145deg,
      rgba(255,255,255,0.095),
      rgba(255,255,255,0.035)
    );

  border: 1px solid rgba(255,255,255,0.10);

  box-shadow:
    0 15px 45px rgba(0,0,0,0.30);

  cursor: pointer;

  transition:
    transform 0.45s ease,
    box-shadow 0.45s ease,
    border-color 0.45s ease;

  &:hover {
    transform: translateY(-10px);

    border-color: rgba(96,165,250,0.35);

    box-shadow:
      0 28px 65px rgba(0,0,0,0.42),
      0 10px 35px rgba(37,99,235,0.13);
  }

  &:hover .project-image {
    transform: scale(1.06);
  }

  &:hover .image-overlay {
    opacity: 0.15;
  }

  &:hover .arrow {
    transform: translateX(-5px);
  }

  @media (max-width: 768px) {
    border-radius: 21px;

    &:hover {
      transform: translateY(-5px);
    }
  }
`;

/* =========================================================
   IMAGE
========================================================= */

const ImageWrapper = styled.div`
  position: relative;

  height: 285px;

  overflow: hidden;

  background: #101827;

  @media (max-width: 768px) {
    height: 255px;
  }
`;

const ProjectImage = styled.img`
  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;

  transition:
    transform 0.8s cubic-bezier(0.2, 0.7, 0.2, 1);

  will-change: transform;
`;

const ImageOverlay = styled.div`
  position: absolute;
  inset: 0;

  background:
    linear-gradient(
      to bottom,
      rgba(0,0,0,0.02) 20%,
      rgba(0,0,0,0.35) 100%
    );

  opacity: 0.7;

  transition: opacity 0.45s ease;
`;

const Number = styled.div`
  position: absolute;

  top: 17px;
  right: 17px;

  width: 42px;
  height: 42px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 13px;

  color: white;

  background: rgba(7, 20, 38, 0.72);

  border: 1px solid rgba(255,255,255,0.14);

  backdrop-filter: blur(12px);

  font-size: 14px;
  font-weight: 800;
`;

const Category = styled.div`
  position: absolute;

  left: 17px;
  bottom: 17px;

  padding: 7px 13px;

  border-radius: 30px;

  color: #dbeafe;

  background: rgba(7, 20, 38, 0.78);

  border: 1px solid rgba(147,197,253,0.18);

  backdrop-filter: blur(10px);

  font-size: 12px;
  font-weight: 700;
`;

/* =========================================================
   CONTENT
========================================================= */

const Content = styled.div`
  padding: 25px 25px 27px;

  @media (max-width: 768px) {
    padding: 22px 20px 24px;
  }
`;

const ProjectTitle = styled.h3`
  margin: 0 0 10px;

  color: #ffffff;

  font-size: 23px;
  line-height: 1.35;

  font-weight: 850;

  letter-spacing: -0.4px;
`;

const Description = styled.p`
  margin: 0;

  min-height: 58px;

  color: #aebbd0;

  font-size: 15px;

  line-height: 1.75;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

/* =========================================================
   FOOTER BUTTON
========================================================= */

const CardFooter = styled.div`
  display: flex;

  align-items: center;
  justify-content: space-between;

  gap: 15px;

  margin-top: 20px;

  padding-top: 18px;

  border-top: 1px solid rgba(255,255,255,0.08);
`;

const VisitButton = styled(Button)`
  display: inline-flex !important;

  align-items: center;
  justify-content: center;

  gap: 9px;

  border: 0 !important;

  border-radius: 12px !important;

  padding: 11px 18px !important;

  color: white !important;

  background:
    linear-gradient(
      135deg,
      #2563eb,
      #6366f1
    ) !important;

  font-size: 14px !important;

  font-weight: 800 !important;

  box-shadow:
    0 8px 22px rgba(37,99,235,0.20);

  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease !important;

  &:hover {
    transform: translateY(-2px);

    box-shadow:
      0 12px 28px rgba(37,99,235,0.35);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Arrow = styled.span`
  display: inline-block;

  font-size: 18px;

  transition: transform 0.3s ease;
`;

const ViewText = styled.span`
  color: #71839b;

  font-size: 12px;
  font-weight: 600;
`;

/* =========================================================
   COMPONENT
========================================================= */

export default function UpdatedSlider() {

  const projects = [
    {
      id: 1,
      title: "S.G One ניקיון ואחזקות",
      url: "https://sg1.co.il/",
      img: pp,
      category: "ניהול ואחזקה",
      desc:
        "עובדי ניקיון, אחזקת מבנים וניהול צוותי ניקיון"
    },

    {
      id: 2,
      title: "נצר הובלות ומנופים",
      url: "https://netzertovala.co.il/",
      img: n5,
      category: "הובלות ומנופים",
      desc:
        "פתרונות מקצועיים להובלה, הרמה ושינוע לכל סוגי הפרויקטים"
    },

    {
      id: 3,
      title: "אוחנה MMA",
      url: "https://teamohanamma.co.il/",
      img: n2,
      category: "ספורט ואומנויות לחימה",
      desc:
        "אומנויות לחימה, כושר ובניית ביטחון עצמי"
    },

    {
      id: 4,
      title: "איטומים בגבהים",
      url: "https://www.itumimb.co.il/",
      img: n3,
      category: "איטום ושיקום",
      desc:
        "שיקום מבנים, איטום גגות ועבודות סנפלינג מקצועיות"
    },

    {
      id: 5,
      title: "ג׳ורדן אדרי הפקות",
      url: "https://www.jordanedri.co.il/",
      img: n4,
      category: "הפקות ואירועים",
      desc:
        "DJ ג׳ורדן אדרי – מוזיקה והפקות לאירועים, חתונות, בר מצוות ואירועי חברה"
    },

    {
      id: 6,
      title: "רישוי עסקים ישראל",
      url: "https://rishuy-asakim.co.il/",
      img: p,
      category: "ייעוץ ורישוי",
      desc:
        "ליווי מקצועי להוצאת רישיון עסק מול כל הרשויות"
    },

    {
      id: 7,
      title: "ש.מ הובלות ומנופים",
      url: "https://smtovala.co.il/",
      img: n6,
      category: "הובלות ומנופים",
      desc:
        "שירותי הובלה, מנופים, הרמות ושינוע בכל הארץ"
    }
  ];

  const openProject = (url) => {
    window.open(
      url,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <MainWrapper>

      <HeaderArea>

        <SmallLabel>
          הפרויקטים שלנו
        </SmallLabel>

        <Title>
          העבודות <span>שלנו</span>
        </Title>

        <Subtitle>
          אנו בונים אתרי אינטרנט מהירים, מודרניים
          ומותאמים לקידום בגוגל, עם עיצוב יוקרתי
          וחוויית משתמש ברמה הגבוהה ביותר.
        </Subtitle>

      </HeaderArea>

      <ProjectsGrid>

        {projects.map((project) => (

          <Card
            key={project.id}
            onClick={() => openProject(project.url)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                openProject(project.url);
              }
            }}
          >

            <ImageWrapper>

              <ProjectImage
                className="project-image"
                src={project.img}
                alt={`אתר ${project.title}`}
                loading="lazy"
              />

              <ImageOverlay className="image-overlay" />

              <Number>
                {String(project.id).padStart(2, "0")}
              </Number>

              <Category>
                {project.category}
              </Category>

            </ImageWrapper>

            <Content>

              <ProjectTitle>
                {project.title}
              </ProjectTitle>

              <Description>
                {project.desc}
              </Description>

              <CardFooter>

                <ViewText>
                  לצפייה באתר
                </ViewText>

                <VisitButton
                  onClick={(e) => {
                    e.stopPropagation();
                    openProject(project.url);
                  }}
                >
                  צפה באתר
                  <Arrow className="arrow">
                    ←
                  </Arrow>
                </VisitButton>

              </CardFooter>

            </Content>

          </Card>

        ))}

      </ProjectsGrid>

    </MainWrapper>
  );
}